/**
* Created by lobin on 2020/6/17.
*/
<template>
  <div class="device-select">
    <a-select
      mode="multiple"
      v-model="val"
      placeholder="选择关联设备"
      style="width: 100%"
      :filterOption="filterOption"
      :not-found-content="fetching ? undefined : null"
    >
      <a-spin v-if="fetching" slot="notFoundContent" size="small" />
      <a-select-option v-for="d in dataSource" :key="d.value" :value="d.value" :text="d.text">
        {{ d.text }}
      </a-select-option>
    </a-select>
  </div>
</template>

<script type="text/babel">
import { getAllDevice } from '@/api/device';

export default {
  props: ['value'],
  data() {
    return {
      dataSource: [],
      fetching: false,
    };
  },
  created() {
    this.getData();
  },
  computed: {
    val: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
  methods: {
    async getData(keyword) {
      const { data } = await getAllDevice({ keyword });
      this.dataSource = data.map(({ _id, name, idCode }) => ({ value: _id, text: `${name}-${idCode}` }));
    },
    filterOption(inputValue, option) {
      const val = String(inputValue).toLowerCase();
      const { text } = option.data.attrs;
      return text.toLowerCase().indexOf(val) > -1;
    },
  },
};
</script>

<style lang="less" rel="stylesheet/less">

</style>
